import React from 'react';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';
import classNames from 'classnames';
import { SummarySectionContainer } from '../../../buy-process-form/components/summary/components/section-container/section-container';
import {
  FormSectionContainerComponent,
  SubSectionProps,
} from './form-section-container-types';

const useStyles = makeStyles(() => ({
  fullWidth: {
    width: '100%',
  },
}));

export const FormSectionContainer: FormSectionContainerComponent = ({
  sectionTitle,
  children,
  className,
  cardClasses,
  fullWidth = true,
}) => {
  const classes = useStyles();
  const containerClasses = classNames(className, {
    [classes.fullWidth]: fullWidth,
  });

  return (
    <div className={containerClasses}>
      {sectionTitle && (
        <Typography variant="subtitle1">{sectionTitle}</Typography>
      )}

      <SummarySectionContainer className={cardClasses}>
        {children}
      </SummarySectionContainer>
    </div>
  );
};

const SubSection = ({
  className,
  title,
  children,
  cardClasses,
}: SubSectionProps) => (
  <div className={className}>
    {title && (
      <Typography variant="subtitle2" gutterBottom>
        {title}
      </Typography>
    )}

    <SummarySectionContainer className={cardClasses}>
      {children}
    </SummarySectionContainer>
  </div>
);

FormSectionContainer.SubSection = SubSection;
